import React, { Fragment, useLayoutEffect } from "react";
import { Row, Col, Typography, Button, Form } from "antd";
import { useForm } from "react-hook-form";
import { InputNumberFieldV2 as InputNumberField } from "../../../atoms/FormElement/InputNumberField";
import { useSelector } from "react-redux";
import { FiRefreshCw } from "react-icons/fi";
/**
 * @author
 * @function @
 **/
const { Text } = Typography;
export const AddCustomPaymentPlan = (props) => {
  const {
    control,
    handleSubmit,
  } = useForm();
  const [screenSize, setScreenSize] = React?.useState("");

  useLayoutEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width >= 1500) {
        setScreenSize("xl");
      } else if (width >= 992) {
        setScreenSize("lg");
      } else {
        setScreenSize("smaller than lg");
      }
    };

    // Initial check
    checkScreenSize();
    // Add event listener to update on resize
    window.addEventListener("resize", checkScreenSize);
    // Clean up the event listener on unmount
    return () => window.removeEventListener("resize", checkScreenSize);
  });
  const onSubmit = (values) => {
    let valueSettings = { ...values };
    valueSettings["isCustomPaymentPlan"] = "yes";
    valueSettings["checked"] = true;
    valueSettings["_key"] = crypto.randomUUID();
    props?.setPaymentScheduler(valueSettings);
  };

  const { bookingDetails, bookingForm } = useSelector(
    (state: any) => state.newBooking
  );

  return (
    <Form
      layout="vertical"
      name="addCustomplansForm"
      className="bf-main"
      scrollToFirstError
      onFinish={handleSubmit(onSubmit)}
    >
      <Row gutter={[4, 16]}>
        <Col span={10}>
          <Text className="fontWeight600 ag-default mb-1">NO OF PAYMENTS</Text>
        </Col>
        <Col span={4}>
          <Text className="fontWeight600 ag-default mb-2">ANNUAL RENT</Text>
        </Col>
        <Col span={screenSize === "lg" ? 4 : 5}>
          <Text className="fontWeight600 ag-default mb-2">NUMBER OF YEARS</Text>
        </Col>
        <Col span={4}>
          <Text className="fontWeight600 ag-default mb-2">
            SECURITY DEPOSIT
          </Text>
        </Col>
        <Col span={screenSize === "lg" ? 2 : 1}>
          {/* <Text className="fontWeight600 ag-default mb-2">Action</Text> */}
        </Col>
      </Row>
      <Row gutter={[6, 16]} className="bf-main">
        <Col span={24} className="ft-divider" />
        {
          <Fragment>
            <Col span={10}>
              <Row>
                {
                  <Col span={12}>
                    <InputNumberField
                      isRequired
                      fieldname={`installments`}
                      control={control}
                      defaultValue={bookingDetails.customPaymentPlan?.installments || 0}
                      inputNumberProps={{
                        min: 1,
                        max: 12,
                        precision: 0,
                      }}
                    />
                  </Col>
                }
              </Row>
            </Col>
            <Col span={4}>
              <InputNumberField
                isRequired
                fieldname={`annualRent`}
                control={control}
                format="currency"
                defaultValue={bookingDetails.customPaymentPlan?.annualRent || 0}
                inputNumberProps={{ min: 1 }}
              />
            </Col>
            <Col span={screenSize === "lg" ? 4 : 5}>
              <InputNumberField
                isRequired
                fieldname={`noOfYear`}
                control={control}
                defaultValue={bookingDetails.customPaymentPlan?.noOfYear || 1}
                inputNumberProps={{
                  min: 1,
                  max: 12,
                  precision: 0,
                }}
              />
            </Col>
            <Col span={4}>
              <InputNumberField
                isRequired
                fieldname={`securityDeposit`}
                control={control}
                format="currency"
                defaultValue={bookingDetails.customPaymentPlan?.securityDeposit || 0}
                inputNumberProps={{ min: 0 }}
              />
            </Col>

            <Col span={1}>
              <Button
                title="Generate custom payment plan"
                disabled={props?.customePlanLoading}
                size="large"
                type="primary"
                className="cc-fotter_next-button"
                htmlType="submit"
              >
                <FiRefreshCw />
              </Button>
            </Col>
          </Fragment>
        }
      </Row>
    </Form>
  );
};
